import { render, staticRenderFns } from "./ModalCambioPasswordObligatorio.vue?vue&type=template&id=153e315c"
import script from "./ModalCambioPasswordObligatorio.vue?vue&type=script&lang=js"
export * from "./ModalCambioPasswordObligatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports